import axios from "axios";
import { SERVER_URL } from "./config";
import jwtAxios from "../util/jwtUtil";

// const prefix = `${API_SERVER_HOST}/login/create`;
const prefix = `${SERVER_URL}`;

export const postSign = async ({
  values,
  address,
  withdrawStatus,
  successFn,
  failFn,
  errFn,
}) => {
  try {
    const url = `${prefix}/login/create`;
    const res = await axios.post(url, {
      ...values,
      address: address,
      // withdrawStatus: withdrawStatus,
    });
    const status = res.status.toString();
    const httpSt = status.charAt(0);
    if (httpSt === "2") {
      return successFn(res.data);
    }
  } catch (error) {
    if (error.request.readyState === 4) {
      return failFn();
    } else {
      errFn("서버에러에요");
    }
  }
};

export const postLogin = async ({ loginParam }) => {
  try {
    // 만약에 API 서버가 JSON 을 원한다면
    const header = { headers: { "Content-Type": "application/json" } };

    const formData = new FormData();
    // formData.append("이름", "값")
    formData.append("username", loginParam.email);
    formData.append("password", loginParam.pw);
    const url = `${prefix}/login`;
    const res = await axios.post(url, loginParam, header);
    // const res = await axios.post(`${host}/login`, formData, header);
    return res.data;
    // const status = res.status.toString();

    // if (status.charAt(0) === "2") {
    //   // 화면 처리용
    //   successFn(res.data);

    //   // RTK 업데이트 하기위해서는 리턴을 해서 값을 전달해야 해
    //   return res.data;
    // } else {
    //   failFn("로그인에 실패하였습니다. 다시 시도해주세요.");
    // }
  } catch (error) {
    console.log(
      "로그인에 실패하였습니다. 서버가 불안정합니다.다시 시도해주세요.",
    );
  }
};
